/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import axios from "axios/dist/axios.min.js";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import utils from "../../utils/utils";
import "./style.less";
import {Parser} from 'json2csv';
import { saveAs } from 'file-saver';
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'

const details = {
  "goodsId": 123,
  "goodsName": "iPhone 18",
  "subtitle": "买就送air pods",
  "goodsUrl": "https://item.taobao.com/item.htm?id=684824549373",
  "imgUrl": "https://static.shihuocdn.cn/admin/files/20221211/1d91ecea5b28a6a426fe74c59d2455f8.jpeg",
  "price": "99.80",
  "discountPrice": "88.80",
  "sale": "1000w+",
  "tags": [
      "包邮",
      "假一赔万"
  ],
  "shopName": "苹果官网",
  "shopId": "666888",
  "shopUrl": "https://shop.m.taobao.com/shop/shop_index.htm?user_id=890482188&item_id=681719765292",
  "specs": [
      {
          "name": "颜色",
          "attrs": [
              {
                  "name": "白色",
                  "image": "https://img.alicdn.com/bao/uploaded/i2/2783679443/O1CN01NWPSVC2JcwqQBChAd_%21%212783679443.jpg_120x120.jpg"
              },
              {
                  "name": "黑色",
                  "image": "https://img.alicdn.com/bao/uploaded/i2/2783679443/O1CN01NWPSVC2JcwqQBChAd_%21%212783679443.jpg_120x120.jpg"
              }
          ]
      },
      {
          "name": "尺码",
          "attrs": [
              {
                  "name": "46.8"
              },
              {
                  "name": "M"
              },
              {
                  "name": "S"
              }
          ]
      }
  ],
  "postage": "免运费",
  "Details": [
    {
      "Type": "Image",
      "Content": "https://img.alicdn.com/imgextra/i2/2819894826/O1CN01qgh0Yl1lWLzzGS4Op_%21%212819894826.jpg"
    },
    {
      "Type": "Image",
      "Content": "https://img.alicdn.com/imgextra/i3/2819894826/O1CN019NgjxY1lWLzyCSxcL_%21%212819894826.jpg"
    },
    {
      "Type": "Text",
      "Content": "这是图文详情的文本类型"
    }
  ],
  "extraShow": [
    "自定义1",
    "自定义2"
  ],
  "extraExport": [
    "自定义3",
    "自定义4"
  ]
}

const productStyle = typeof window !== "undefined" && window.localStorage.getItem('productStyle') || '';
class PipelineCheckAppProduct extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      showPage: 1,
      pageSize: 0,
      url: "",
      detail: {},
      export: "off",
      page_type: "",
      productStyle: productStyle || props.config.cardBaseConfig.productStyle
    };
    this.delayScroll = null;
    this.delayUpload = null;
    this.exportLock = false;
  }

  componentDidMount() {

    window.addEventListener("message", this.receiveMessage, false);
    document.getElementsByTagName('body')[0].style.paddingLeft = '20%';
    document.getElementsByTagName('body')[0].style.paddingRight = '10%';

    const testData = {
      "type": "list",
      "clear_data": false,
      "message": "",
      "data": "[{\"discountPrice\":\"994.00\",\"goodsId\":\"662634038106\",\"goodsName\":\"Jordan官方耐克乔丹AIR JORDAN 1 ELEVATE 女子运动鞋休闲DH7004\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=662634038106\",\"imgUrl\":\"https://g.search3.alicdn.com/img/i3/125054740/O1CN01wGS2y11ksy799eshr_!!0-saturn_solar.jpg\",\"price\":\"994.00\",\"sale\":\"0\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"\",\"tags\":[\"已抵5元红包\",\"包邮\"]},{\"discountPrice\":\"0.01\",\"goodsId\":\"694331772832\",\"goodsName\":\"Nike Air Force 1 AF1纯白空军一号低帮男女经典板鞋 315123-111\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694331772832\",\"imgUrl\":\"https://g.search2.alicdn.com/img/bao/uploaded/i4/i3/3413497412/O1CN01vyQuJM24ckROiGxFi_!!3413497412.jpg\",\"price\":\"0.00\",\"sale\":\"13\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"高帮（帮高大于20cm)包裹性系带\",\"tags\":[\"已抵0.01元红包\",\"包邮\"]},{\"discountPrice\":\"799.00\",\"goodsId\":\"693954468956\",\"goodsName\":\"Nike耐克AIR FORCE 1空军一号AF1纯白高低帮男女鞋小白鞋休闲板鞋\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=693954468956\",\"imgUrl\":\"https://g.search1.alicdn.com/img/bao/uploaded/i4/i4/2214817327669/O1CN01kAqMub26WSE5Wq97T_!!2214817327669.jpg\",\"price\":\"213.00\",\"sale\":\"139\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"休闲鞋透气橡胶底\",\"tags\":[\"已抵5元红包\",\"公益宝贝\",\"包邮\"]},{\"discountPrice\":\"0.01\",\"goodsId\":\"694343489841\",\"goodsName\":\"Air Jordan 1 Low AJ1激光蓝黑红蓝黄黑粉脚趾低帮板鞋男女\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694343489841\",\"imgUrl\":\"https://g.search2.alicdn.com/img/bao/uploaded/i4/i1/2206780516183/O1CN01tKsudz1vXrfnF6tqH_!!2206780516183.jpg\",\"price\":\"0.00\",\"sale\":\"18\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"\",\"tags\":[\"已抵0.01元红包\",\"包邮\"]},{\"discountPrice\":\"799.00\",\"goodsId\":\"694535278762\",\"goodsName\":\"耐克女鞋Nike Air Force 1空军一号AF1奶咖板鞋男鞋高低帮运动鞋\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694535278762\",\"imgUrl\":\"https://g.search.alicdn.com/img/bao/uploaded/i4/i3/2214817327669/O1CN01IW8cSa26WSE0olBNH_!!2214817327669.jpg\",\"price\":\"213.00\",\"sale\":\"68\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"休闲鞋透气橡胶底\",\"tags\":[\"已抵5元红包\",\"公益宝贝\",\"包邮\"]},{\"discountPrice\":\"0.01\",\"goodsId\":\"695089763975\",\"goodsName\":\"Court Borough Low 黑曜石蓝白女子低帮休闲板鞋 BQ5448-107\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=695089763975\",\"imgUrl\":\"https://g.search.alicdn.com/img/bao/uploaded/i4/i1/2209262481110/O1CN01Zzbo9q1K4QQpxoYmG_!!2209262481110.jpg\",\"price\":\"0.00\",\"sale\":\"13\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"低帮（帮高小于10cm)轻质系带\",\"tags\":[\"已抵0.01元红包\",\"包邮\"]},{\"discountPrice\":\"0.01\",\"goodsId\":\"694123784296\",\"goodsName\":\"Nike Dunk Low 玫瑰粉黑白熊猫蓝灰青苹果蓝树莓耐克休闲低帮板鞋\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694123784296\",\"imgUrl\":\"https://g.search1.alicdn.com/img/bao/uploaded/i4/i4/2208059819997/O1CN01VTuhR72NigGhHWrts_!!2208059819997.jpg\",\"price\":\"0.00\",\"sale\":\"26\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"低帮（帮高小于10cm)速干系带\",\"tags\":[\"已抵0.01元红包\",\"包邮\"]},{\"discountPrice\":\"310.00\",\"goodsId\":\"694131788030\",\"goodsName\":\"耐克Nike Dunk Low 米棕绿复古潮流低帮男子滑板鞋FB7160-231\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694131788030\",\"imgUrl\":\"https://g.search.alicdn.com/img/bao/uploaded/i4/i4/2214883121136/O1CN01S0fmHm1KGKjGj6R00_!!2214883121136.jpg\",\"price\":\"305.00\",\"sale\":\"58\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"低帮（帮高小于10cm)耐磨系带\",\"tags\":[\"已抵5元红包\",\"包邮\"]},{\"discountPrice\":\"168.00\",\"goodsId\":\"691708986443\",\"goodsName\":\"Nike耐克鸭舌帽男女可调节\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=691708986443\",\"imgUrl\":\"https://g.search.alicdn.com/img/bao/uploaded/i4/i2/1970687638/O1CN01o9TbsN26IFwGEUxsc_!!1970687638.png\",\"price\":\"55.00\",\"sale\":\"902\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"\",\"tags\":[\"已抵5元红包\",\"直降21元\",\"新品\",\"全球购\",\"包邮\"]},{\"discountPrice\":\"629.00\",\"goodsId\":\"682350583983\",\"goodsName\":\"Nike耐克男子训练鞋透气\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=682350583983\",\"imgUrl\":\"https://g.search1.alicdn.com/img/bao/uploaded/i4/i4/890482188/O1CN01pVHLFU1S29NPvhN8n_!!2-item_pic.png\",\"price\":\"374.00\",\"sale\":\"2758\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"\",\"tags\":[\"已抵5元红包\",\"新品\",\"包邮\"]},{\"discountPrice\":\"799.00\",\"goodsId\":\"694765962335\",\"goodsName\":\"耐克NIKE AIR FORCE 1空军一号AF1纯白低帮女鞋小白鞋休闲板鞋男\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694765962335\",\"imgUrl\":\"https://g.search2.alicdn.com/img/bao/uploaded/i4/i3/2214954659527/O1CN01NAtRt42KFQ7MwuDRY_!!2214954659527.jpg\",\"price\":\"303.00\",\"sale\":\"17\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"休闲鞋透气橡胶底\",\"tags\":[\"已抵5元红包\",\"公益宝贝\",\"包邮\"]}]"
    }

    // this.addList(testData);

    setTimeout(() => {
      typeof window !== "undefined" 
        && window.parent
        && window.parent.postMessage({
          messageType: 'initList'
        }, '*');
    }, 1000)
  }

  destroyed() {
    typeof window !== "undefined" && window.removeEventListener("message", this.receiveMessage, false)
    if (this.delayScroll) {
      clearTimeout(this.delayScroll);
      this.delayScroll = null;
    } 
  }

  initSwiper = () => {
    var mySwiper = new Swiper('.banner', {
      autoplay: true,
      loop: true
    })
  }

  receiveMessage = (event) => {
    const { messageType = '', data = '' } = event.data;
    switch (messageType) {
      case '列表数据':
        this.addList(data);
        break;
      case '清除数据':
        this.clearData();
        break;
      case '记录导出':
        this.exportRecord(messageType);
        break;
      case '执行导出':
        this.exportRecord(messageType);
        break;
      case '展示风格':
        this.showType(data);
        break;
      case '刷新列表':
        this.refreshList(data);
        break;
      default:
        break;
    }
  }

  refreshList = (data) => {
    const productStyle = data === '单列展示' ? '一行一个': '一行两个';
    typeof window !== "undefined" && window.localStorage.setItem('productStyle', productStyle);
    this.clearData();
  }

  showType = (data) => {
    const productStyle = data === '单列展示' ? '一行一个': '一行两个';
    if (productStyle === this.state.productStyle) {
      return;
    }
    const list = this.state.list;
    if (list && list.length > 0) {
      window.parent && window.parent.postMessage({
        messageType: 'refreshTips',
        data: data
      }, '*');
    } else {
      this.setState({
        productStyle
      });
    }
  }

  // 详情页数据
  getDetail(data) {
    let detail = {};
    if (data) {
      detail = data.data ? JSON.parse(data.data) : {};
    } else {
      detail = details;
    }
    this.setState({
      page_type: "detail",
      detail
    }, () => {
      this.initSwiper();
    });
  }
  // 清楚数据
  clearData() {
    this.setState({
      list: [],
    }, () => {
      typeof window !== "undefined" && window.location.reload();
    });
  }

  // 记录导出
  exportRecord(messageType) {
    this.setState({
      export: messageType === "记录导出" ? "on" : "off"
    })
  }

  imgProxy = (origin) => {
    let base64 = window.btoa(unescape(encodeURIComponent(origin)))
    base64 = base64.replace(new RegExp("/", "g"), "_")
    base64 = base64.replace(new RegExp('\\+', "g"), "-")
    base64 = base64.replace(new RegExp('=', "g"), "")
    return `https://proxy.shihuocdn.cn/${base64}`
  }

  imageUrl(origin) {
    return `https://proxy.shihuocdn.cn/${window.btoa(unescape(encodeURIComponent(origin)))}`
  }

  addList(data) {
    console.log('======== addList Lego获取到数据 =======', data);
    // 后端通知主动清除列表数据
    if (data.clear_data) {
      this.setState({
        page_type: "list",
        list: [],
      })
    }

    // 数据格式转换
    const listLength = this.state.list.length;
    const list_original = JSON.parse(data.data);
    const list = list_original.map(item => {
      const element = {
        id: null,
        goods_id: item.goodsId,
        title: item.goodsName,
        sub_title: item.subtitle,
        url: item.goodsUrl,
        image: this.imgProxy(item.imgUrl),
        price: item.price,
        original_price: '',
        recommend: item.recommendReason,
        sell_point: item.sale,
        sell_point_str: item.sale,
        shop_id: item.shopId,
        shop_name: item.shopName,
        tags: item.tags,
        extraShow: item.extraShow,
        extraExport: item.extraExport
      }
      return element;
    });
    this.setState({
      page_type: "list",
      list: [...this.state.list, ...list]
    }, () => {

      // 翻到指定位置
      if (this.state.list.length > 0) {
        try {
          const productItem = document.getElementsByClassName(("product-item-" + (this.state.list.length - list.length)));
          if (this.delayScroll) {
            clearTimeout(this.delayScroll);
            this.delayScroll = null;
          }
          this.delayScroll = setTimeout(() => {
            if (listLength <= 0) {
              window.scrollTo(0, 5);
            } else {
              window.scrollTo(0, productItem[0].offsetTop)
            }

            setTimeout(() => {
              // 整合渠道检查数据，进行上报
              console.log('上报开关 ======', this.state.export);
              if (this.state.export === "on") {
                this.exportCsv(list_original, listLength);
              }
            }, 4000);
          }, 2000);
        } catch (e) {
          console.log(e.message)
        }
      }
    })
  }

  async exportCsv(list = [], start = 0) {
    if (this.exportLock || list.length <= 0) {
      return
    }
    this.exportLock = true
    
    try {
      let uploadData = []
      for (const index in list) {
        const item = list[index];
        const uploadItem = {
          "raw_data": item,
          "plugin_data": []
        }
        const projectClass = document.getElementsByClassName("product-item-" + (Number(index) + Number(start)));
        if (projectClass && projectClass[0]) {
          const dataItem = projectClass[0].getAttribute("data-item")
          Object.assign(uploadItem, {
            "plugin_data": dataItem ? JSON.parse(dataItem) : []
          })
        }
        uploadData.push(uploadItem)
      }
      console.log('uploadData', uploadData);

      window.parent && window.parent.postMessage({
        messageType: 'uploadData',
        data: uploadData,
      }, '*');

      this.exportLock = false
    } catch (e) {
      console.log('upload err', e);
      this.exportLock = false
    } finally {
      this.exportLock = false
    }
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }

    const { baseConfig, cardBaseConfig } = this.props.config;

    const options = {
      title: baseConfig.title,
      type: this.state.productStyle,
      sort: index,
      name: item.title
    };
    if (baseConfig.productType === "商品id" || (cardBaseConfig && cardBaseConfig.productType === "商品id")) {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    if (cardBaseConfig.jumpType === '新标签页跳转') {
      window.open(item.url);
    } else {
      utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);
    }
  }

  // 进入店铺
  goShop = (url) => {
    url && window.open(url);
  }

  render() {
    const { list, showPage, page_type = "", productStyle } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig } = this.props.config;
    const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 375;
    let productList = [];
    // 判断不同布局方式下的间距取值
    if (productStyle === "一行一个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_1);
      productList = baseConfig.showFoldBtn ? (showPage <= 1 ? list.slice(0, 6) : list.slice(0, 6 + 10 * (showPage - 1))) : list;
    } else if (productStyle === "一行两个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_2);
      productList = baseConfig.showFoldBtn ? (showPage <= 1 ? list.slice(0, 6) : list.slice(0, 6 + 10 * (showPage - 1))) : list;
    }
    // 转为数字处理，后续参与计算
    cardBaseConfig.itemMargin = isNaN(Number(cardBaseConfig.itemMargin))
      ? 0
      : Number(cardBaseConfig.itemMargin);

    const inputWidth = `calc((100% - 342px))`;

    if (page_type === "list") {
      return (
        <div
          className="pipeline-checkAppProduct"
          id={baseConfig.title}
          {...this.props['customAttributes']}
        >
          {productStyle !== "一行一排" ? (
            <div className="product-list">
              {productList.map((item, index) => {
                let rowItemNumber = 3; // 每行排列数量
                if (productStyle === "一行一个") {
                  rowItemNumber = 1;
                } else if (productStyle === "一行两个") {
                  rowItemNumber = 2;
                }
  
                // 行数计算
                const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
                const totalRowNum = Math.ceil(productList.length / rowItemNumber);
                const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
                const isLasthRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
                const isFirstColumn = Boolean(index % rowItemNumber === 0);
                const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列
  
                // 计算每个项的宽度
                const totalMargin = (rowItemNumber - 1) * cardBaseConfig.itemMargin;
                const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
                const itemStyle = {
                  width: itemWidth,
                  marginTop: isFirstRow ? "0" : `${cardBaseConfig.itemMargin / 2}px`,
                  marginBottom: isLasthRow
                    ? "0"
                    : `${cardBaseConfig.itemMargin / 2}px`,
                  marginLeft: isFirstColumn
                    ? "0"
                    : `${cardBaseConfig.itemMargin / 2}px`,
                  marginRight: isLastColumn
                    ? "0"
                    : `${cardBaseConfig.itemMargin / 2}px`,
                };
  
                cardBaseConfig.cardBackground && Object.assign(itemStyle, {
                  backgroundImage: `url(${cardBaseConfig.cardBackground})`,
                  backgroundSize: "100% 100%",
                  backgroundColor: "transparent",
                  backgroundRepeat: "no-repeat",
                  borderRadius: "inherit"
                })
  
                let productItem;
                if (productStyle === "一行一个") {
                  // 三个展示都存在时，隐藏销量
                  if (
                    (cardInfoConfig.originPrice || cardInfoConfig.discount) &&
                    cardInfoConfig.saleNum &&
                    cardInfoConfig.priceIcon
                  ) {
                    cardInfoConfig.saleNum = false;
                  }
                  productItem = (
                    <div
                      className={["product-item", "row-one-item", "product-item-"+index].join(" ")}
                      key={`productItem-${index}`}
                      style={itemStyle}
                      onClick={this.handleItemClick.bind(this, item, index)}
                      data-url={item.url+`&SHRANDOM=${parseInt(Math.random()*(999999-100000)+100000)}`}  // 杨祺要求的
                      data-shopid={item.shop_id}
                      data-shopname={item.shop_name}
                    >
                      <div className="product-img-panel">
                        <LazyLoadImage
                          width={88}
                          height={88}
                          src={item.image}
                        />
                      </div>
                      <div className="product-info">
                        <div className="info">
                          <div
                            className={cardInfoConfig.slogen && cardInfoConfig.unitPrice ? "name line-clamp-2" : "name"}
                            style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor }}
                          >
                            {item.useCustomName ? item.custom_title : item.title}
                          </div>
                          {
                            item.sub_title && (
                              <div
                                className={"sub-title"}
                                style={{ WebkitBoxOrient: "vertical"  }}
                              >
                                {item.sub_title}
                              </div>
                            )
                          }
                          {cardInfoConfig.slogen && (
                            <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>
                              {(item.recommendType === '推荐理由') ? item.recommend : item.custom_recommend}
                            </p>
                          )}
                          {(item.shoppersLabel === '单位价格' && cardInfoConfig.unitPrice && item.unit_price_text) && (
                            <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                              {item.unit_price_text}
                            </p>
                          )}
                          {(item.shoppersLabel === '自定义' && cardInfoConfig.unitPrice && item.custom_unitPrice) && (
                            <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                              {item.custom_unitPrice}
                            </p>
                          )}
                        </div>
                        <div className="sale">
                          <div className="price-container">
                            {cardBaseConfig.priceIcon && (
                              <img
                                className="price-icon"
                                src={utils.formatImgUrl(cardBaseConfig.priceIcon, this.props.webpSupport)}
                              />
                            )}
                            <div className="price" style={{color: baseConfig.priceColor}}>
                              <span className="rmb-icon">¥</span>
                              {item.price}
                            </div>
                          </div>
                          {item.sell_point && (
                            <div className="num" style={{color: baseConfig.priceInfoColor}}>{item.sell_point_str}</div>
                          )}
                        </div>
                        {
                          item.tags.length > 0 && (
                            <div className="shop-tags">
                              {
                                item.tags.map((item, index) => {
                                  if (item) {
                                    return <p key={`tag-${index}`}>{item}</p>
                                  } else {
                                    return null
                                  }
                                })
                              }
                            </div>
                          )
                        }
                      </div>
                      {
                        cardInfoConfig.markIcon && (item.custom_markIcon || cardBaseConfig.markIcon) && (
                          <img className="mark-icon" src={utils.formatImgUrl(item.custom_markIcon || cardBaseConfig.markIcon, this.props.webpSupport)} />
                        )
                      }
                    </div>
                  );
                } else if (productStyle === "一行两个") {
                  // 四个展示都存在是，隐藏销量
                  if (
                    (cardInfoConfig.originPrice || cardInfoConfig.discount) &&
                    cardInfoConfig.saleNum &&
                    cardBaseConfig.priceIcon
                  ) {
                    cardInfoConfig.saleNum = false;
                  }
                  // 计算一行二商品图片宽度
                  let productImgWidth = (bodyWidth - 242 - Number(cardBaseConfig.moduleMarginHorizon) * 2 - Number(cardBaseConfig.itemMargin)) / 2 - 8;
                  productImgWidth = productImgWidth > 268 ? 268 : productImgWidth;
                  let extraShow = item.extraShow ? Object.values(item.extraShow) : [];
                  productItem = (
                    <div
                      className={["product-item", "row-two-item", "product-item-"+index].join(" ")}
                      key={`productItem-${index}`}
                      style={itemStyle}
                      onClick={this.handleItemClick.bind(this, item, index)}
                      data-url={item.url+`&SHRANDOM=${parseInt(Math.random()*(999999-100000)+100000)}`}  // 杨祺要求的
                      data-shopid={item.shop_id}
                      data-shopname={item.shop_name}
                    >
                      <div className="product-img-panel" style={{ marginTop: 4, marginBottom: 4, paddingLeft: 4, paddingRight: 4 }}>
                        <div className="img-wrap">
                          <LazyLoadImage
                            width={productImgWidth}
                            height={productImgWidth}
                            src={item.image}
                          />
                          {
                            item.beltImg && <img src={utils.formatImgUrl(item.beltImg, this.props.webpSupport)} alt="" className="beltImg" />
                          }
                        </div>
                      </div>
                      <div className="product-info">
                        <div className="info">
                          <div
                            className={"name"}
                            style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor  }}
                          >
                            {item.title}
                          </div>
                          {
                            item.sub_title && (
                              <div
                                className={"sub-title"}
                                style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor  }}
                              >
                                {item.sub_title}
                              </div>
                            )
                          }
                          <div className="tag" style={{ color: cardBaseConfig.productTagColor }}>
                            {item.recommendType === '推荐理由' ? item.recommend : item.custom_recommend}
                          </div>
                          {(item.unit_price_text) && (
                            <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                              {item.unit_price_text}
                            </p>
                          )}
                          {(item.custom_unitPrice) && (
                            <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                              {item.custom_unitPrice}
                            </p>
                          )}
                        </div>
                        <div className="sale">
                          <div className="price-container">
                            {cardBaseConfig.priceIcon && (
                              <img
                                className="price-icon"
                                src={utils.formatImgUrl(cardBaseConfig.priceIcon, this.props.webpSupport)}
                              />
                            )}
                            <div className="price" style={{color: baseConfig.priceColor}}>
                              <span className="rmb-icon">¥</span>
                              {item.price}
                            </div>
                          </div>
                          {item.sell_point && (
                            <div className="num" style={{color: baseConfig.priceInfoColor}}>{item.sell_point_str}</div>
                          )}
                        </div>
                        {
                          item.tags.length > 0 && (
                            <div className="shop-tags">
                              {
                                item.tags.map((item, index) => {
                                  if (item) {
                                    return <p key={`tag-${index}`}>{item}</p>
                                  } else {
                                    return null
                                  }
                                })
                              }
                            </div>
                          )
                        }
                        {
                          item.shop_name && <p className="shop-name">{item.shop_name}</p>
                        }
                        <div className="custom-info">
                          {
                            extraShow && extraShow.length > 0 && extraShow.map((item, index) => {
                              return <p key={`custom-field-${index}`} className="custom-field">{item}</p>
                            })
                          }
                        </div>
                      </div>
                    </div>
                  );
                }
                return productItem;
              })}
            </div>
          ) : this.renderLayoutRow()}
        </div>
      );
    } else if (page_type === "detail") {
      return this.renderDetail()
    } else {
      return null;
    }
  }

  renderDetail() {
    const { detail = {} } = this.state;
    const { specs = [] } = detail;
    return(
      <div className="pipeline-checkAppDetail">
        <div className="banner swiper">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              { detail.imgUrl && <img src={detail.imgUrl} alt="" /> }
            </div>
          </div>
        </div>
        <div className="detail-info">
          <div className="price-info">
            <p className="price">{detail.price && `¥${detail.price}`}</p>
            <p className="discount-price">{detail.discountPrice && `券后价 ¥${detail.discountPrice} 起`}</p>
          </div>
          <p className="title">{detail.goodsName}</p>
          <p className="sub-title">{detail.subtitle}</p>
        </div>
        <div className="size-color">
          {
            specs && specs.length > 0 && specs.map((item, index) => {
              return (
                <div className="attr-wrap" key={`attr-${index}`}>
                  <label className="label">{item.name}</label>
                  <ul className="attr">
                    {
                      item && item.attrs && item.attrs.length > 0 && item.attrs.map((value, key) => {
                        return (
                          <li key={`attr-item-${key}`}>
                            { value.image ? <img src={value.image} alt="" /> : value.name }
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              )
            })
          }
        </div>
        <div className="service">
          <div className="freight">
            <label className="label">运费</label>
            <p>{detail.postage}</p>
          </div>
          <ul className="tags">
            { 
              detail.tags && detail.tags.length > 0 && detail.tags.map((item, index) => {
                return <li key={`tag-item-${index}`}>{item}</li>
              }) 
            }
          </ul>
        </div>
        <div className="extra-info">
          <div className="shop-info">
            <img src="" alt="" />
            <p className="">{detail.shopName}</p>
          </div>
          { detail.shopUrl && <div className="shop-btn" onClick={() => this.goShop(detail.shopUrl)}>进入店铺</div> }
          <div className="desc-info">
            {
              detail.Details && detail.Details.length > 0 && detail.Details.map((item, index) => {
                if (item.Type === 'Image') {
                  return <img key={`desc-item-${index}`} src={item.Content} alt="" />
                }
                if (item.Type === 'Text') {
                  return <p key={`desc-item-${index}`}>{item.Content}</p>
                }
              })
            }
          </div>
        </div>
      </div>
    )
  }

  renderLayoutRow() {
    return null;
  }
}

PipelineCheckAppProduct.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCheckAppProduct };
export default PipelineCheckAppProduct;



// WEBPACK FOOTER //
// ./components/pipeline-checkAppProduct/index.js